import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statics',
  templateUrl: './statics.component.html',
  styleUrls: ['./statics.component.sass']
})
export class StaticsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
